import environmentConfig from './utils/configs';

const appVersion = import.meta.env.VITE_SENTRY_RELEASE || '0.0.0';
const sentryDsn = import.meta.env.VITE_SENTRY_DSN ?? environmentConfig.sentryDsn ?? '';

const config = {
    EVENT_NAMESPACE: 'beststart-logging-web',
    audience: 'beststart-logging-web',
    gitBranch: null,
    version: appVersion,
    namespace: 'beststart-logging-web',
    tag: 'beststart-logging-web',
    env: import.meta.env.MODE,
    loggingApiUrl: environmentConfig.loggingApiUrl,
    LogLevel: environmentConfig.LogLevel || 0,
    sampleRate: environmentConfig.sampleRate || 0,
    sentry: {
        dsn: sentryDsn,
    },
    authentication: {
        clientId: environmentConfig.clientId,
        authority: environmentConfig.authority,
        authBaseUrl: environmentConfig.loggingApiUrl,
        redirectUri: window.location.hostname === "localhost.lambdatest.com"
            ? 'https://localhost.lambdatest.com:50330/login'
            : `${window.location.origin}/login`,
    },
};

export default config;
